module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUCAYAAABiS3YzAAAAAXNSR0IArs4c6QAAAFNJREFUOBFj+M/AoAXEVxmoAGBmMVHBLAwjho6hGE4fYQKwZEANb8PMGjqxTxOXUiMoh7IZsGRADT/AzKJJRA0dQ6kRlNjNgAbwfyANw/DqhRw5ACO5LOZrGZ7OAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/Hcp-icon/legend/Auto Suspend 2.png
// module id = 104
// module chunks = 7